module.exports = __webpack_public_path__ + "img/icon-chevron-left.5331901c.svg";